import styled from 'styled-components';

export const AdminPage = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 32px;
`;

export const AdminPageHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AdminPageTitle = styled.h1`
  margin: 0;
  color: #171719;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.36;
  letter-spacing: -0.02em;
`;

export const AdminSection = styled.section`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 32px;
`;

export const AdminCard = styled.div`
  border: 1px solid rgba(112, 115, 124, 0.22);
  border-radius: 12px;
  background: #fff;
  box-sizing: border-box;
`;
